import { Routes, Route } from 'react-router';
import DashboardLayout from '../layouts/DashboardLayout/DashboardLayout';
import Dashboard from '../pages/Dashboard/Dashboard';

import StudentSection from '../pages/StudentSection/StudentSection';
import Staff from '../pages/Staff/Staff';
import Rooms from '../pages/Rooms/Rooms';
import Groups from '../pages/Groups/Groups';
import Labels from '../pages/Labels/Labels';
import EmailTemplate from '../pages/EmailTemplate/EmailTemplate';

import StudentAttendancePage from '../pages/StudentAttendancePage/StudentAttendancePage';
import StaffAttendancePage from '../pages/StaffAttendancePage/StaffAttendancePage';
import StudentLeaves from '../pages/StudentLeaves/StudentLeaves';
import StaffLeaves from '../pages/StaffLeaves/StaffLeaves';
import StudentStaffRatio from '../pages/StudentStaffRatio/StudentStaffRatio';
import AttendanceForecast from '../pages/AttendanceForecast/AttendanceForecast';

import Program from '../pages/Program/Program';
import ProgramDashboard from '../pages/ProgramDashboard/ProgramDashboard';
import RoomMovement from '../pages/RoomMovement/RoomMovement';

import EnquiriesScreen from '../../src/pages/EnquiriesScreen/EnquiriesScreen';
import EnquiriesDashboard from '../../src/pages/EnquiresDashboard/EnquiresDashboard';
import ViewArchived from '../../src/pages/ViewArchived/ViewArchived';
import CheckUp from '../pages/CheckUp/CheckUp';
import Tasks from '../pages/Tasks/Tasks';
import EnquiryForms from '../pages/EnquiryForms/EnquiryForms';
import FormEmailTemplate from '../pages/FormEmailTemplate/FormEmailTemplate';
import EnquiryAutomation from '../pages/EnquiryAutomation/EnquiryAutomation';
import FacebookInt from '../pages/FacebookInt/FacebookInt';

import FeePlan from '../pages/FeePlan/FeePlan';
import FeeEmailTemplate from '../pages/FeeEmailTemplate/FeeEmailTemplate';
import FeeComponent from '../pages/FeeComponent/FeeComponent';

import FeeRemainder from '../pages/FeeRemainder/FeeRemainder';

import AccountingDashboard from '../pages/AccountingDashboard/AccountingDashboard';
import StudentBalance from '../pages/StudentBalance/StudentBalance';
import Expenses from '../pages/Expenses/Expenses';
import Deposits from '../pages/Deposits/Deposits';
import DepositHistory from '../pages/DepositHistory/DepositHistory';
import CreditHistory from '../pages/CreditHistory/CreditHistory';
import CreditBalance from '../pages/CreditBalance/CreditBalance';
import DebitNotes from '../pages/DebitNotes/DebitNotes';
import Payments from '../pages/Payments/Payments';
import Invoices from '../pages/Invoices/Invoices';
// import AllMessaging from '../sections/AllMessaging/AllMessaging';

import Messaging from '../pages/Messaging/Messaging';
import StaffMessages from '../pages/StaffMessages/StaffMessages';
import Announcement from '../pages/Announcement/Announcement';
import StudentForms from '../pages/StudentForms/StudentForms';
import StaffForms from '../pages/StaffForms/StaffForms';
import AdmissionProcess from '../pages/AdmissionProcess/AdmissionProcess';

import StudentFormBuilder from '../../src/pages/StudentFormBuilder/StudentFormBuilder';
import FormBuilderPage from '../pages/FormBuilderPage/FormBuilderPage';
import ExcelReports from '../pages/ExcelReports/ExcelReports';
import ParentReports from '../pages/ParentReports/ParentReports';
import StaffReports from '../pages/StaffReports/StaffReports';
import StaffSchedule from '../pages/StaffSchedule/StaffSchedule';
import StudentSchedule from '../pages/StudentSchedule/StudentSchedule';
import StaffHolidays from '../pages/StaffHolidays/StaffHolidays';
import Birthdays from '../pages/Birthdays/Birthdays';

import SchoolCalendar from '../pages/SchoolCalendar/SchoolCalendar';

import NewsLettersPage from '../pages/NewsLettersPage/NewsLettersPage';
import ActivitiesPage from '../pages/ActivitiesPage/ActivitiesPage';
import ActivitiesSettingsPage from '../pages/ActivitiesSettingsPage/ActivitiesSetttingsPage';
import UpcomingInvoices from '../pages/UpcomingInvoices/UpcomingInvoices';
import Lessons from '../pages/Lessons/Lessons';
import Records from '../pages/Records/Records';
import Reports from '../pages/Reports/Reports';
import Assessments from '../pages/Assessments/Assessments';
import LearningJourney from '../pages/LearningJourney/LearningJourney';
import Manage from '../pages/Manage/Manage';
import Curriculam from '../pages/Curriculam/Curriculam';
import AssessReports from '../pages/AssessReports/AssessReports';
import CompleteStudentPage from '../pages/CompleteStudentPage/CompleteStudentPage';
import DownloadReports from '../pages/DownloadReports/DownloadReports';
import CompleteStaffPage from '../pages/CompleteStaffPage/CompleteStaffPage';

function AppRoutes() {
  return (
    <Routes>
      {/* Standalone Routes */}
      <Route path="/checkUp" element={<CheckUp />} />
      {/* Routes inside Dashboard layout */}
      <Route path="/" element={<DashboardLayout />}>
        <Route path="" element={<Dashboard />} />

        {/* Management */}
        <Route path="management/students" element={<StudentSection />} />
        <Route
          path="management/students/download/reports"
          element={<DownloadReports />}
        />

        <Route
          path="management/students/profile"
          element={<CompleteStudentPage />}
        />
        <Route path="management/staff" element={<Staff />} />
        <Route
          path="management/staff/profile"
          element={<CompleteStaffPage />}
        />
        <Route path="management/rooms" element={<Rooms />} />
        <Route path="management/groups" element={<Groups />} />
        <Route path="management/labels" element={<Labels />} />
        <Route path="management/email-templates" element={<EmailTemplate />} />

        {/* Attendance */}
        <Route path="attendance/students" element={<StudentAttendancePage />} />
        <Route path="attendance/staff" element={<StaffAttendancePage />} />
        <Route path="attendance/studentleaves" element={<StudentLeaves />} />
        <Route path="attendance/staffleaves" element={<StaffLeaves />} />
        <Route path="attendance/ratio" element={<StudentStaffRatio />} />
        <Route path="attendance/forecast" element={<AttendanceForecast />} />

        {/* Program */}
        <Route path="program/program" element={<Program />} />
        <Route path="program/programdashboard" element={<ProgramDashboard />} />
        <Route path="program/roommovement" element={<RoomMovement />} />

        {/* Communication */}
        <Route path="communication/activities" element={<ActivitiesPage />} />
        <Route
          path="communication/activities/settings"
          element={<ActivitiesSettingsPage />}
        />
        <Route
          path="/communication/newsletters"
          element={<NewsLettersPage />}
        />

        {/* Enquiries */}
        <Route path="enquiries/dashboard" element={<EnquiriesDashboard />} />
        <Route path="enquiries/enquiriesscreen" element={<EnquiriesScreen />} />
        <Route path="/view-archived" element={<ViewArchived />} />
        <Route path="enquiries/tasks" element={<Tasks />} />
        <Route path="enquiries/enquiryforms" element={<EnquiryForms />} />
        <Route
          path="enquiries/emailtemplates"
          element={<FormEmailTemplate />}
        />
        <Route
          path="enquiries/enquiryautomation"
          element={<EnquiryAutomation />}
        />
        <Route path="enquiries/facebookint" element={<FacebookInt />} />

        {/* Fee Plan */}
        <Route path="feeplan/feeplan" element={<FeePlan />} />
        <Route path="feeplan/feeemailtemplate" element={<FeeEmailTemplate />} />
        <Route path="feeplan/feecomponent" element={<FeeComponent />} />
        <Route path="feeplan/feeremainder" element={<FeeRemainder />} />

        {/* Accounting */}
        <Route path="accounting/dashboard" element={<AccountingDashboard />} />
        <Route path="accounting/studentbalance" element={<StudentBalance />} />
        <Route path="accounting/invoices" element={<Invoices />} />
        <Route path="accounting/payments" element={<Payments />} />
        <Route path="accounting/debitnotes" element={<DebitNotes />} />
        <Route path="accounting/creditbalance" element={<CreditBalance />} />
        <Route path="accounting/deposits" element={<Deposits />} />
        <Route path="/credithistory" element={<CreditHistory />} />
        <Route path="/deposithistory" element={<DepositHistory />} />
        <Route path="accounting/expenses" element={<Expenses />} />
        <Route
          path="accounting/upcominginvoices"
          element={<UpcomingInvoices />}
        />
        <Route
          path="accounting/accountingemailtemplate"
          element={<FeeEmailTemplate />}
        />
        {/* Messaging */}
        <Route path="messages/allmessaging" element={<Messaging />} />
        <Route path="messages/staffmessages" element={<StaffMessages />} />
        <Route path="messages/announcement" element={<Announcement />} />

        {/* Forms */}

        <Route path="assessments/lessons" element={<Lessons />} />
        <Route path="assessments/records" element={<Records />} />
        <Route path="assessments/reports" element={<Reports />} />
        <Route path="assessments/assessments" element={<Assessments />} />
        <Route
          path="assessments/learningjourney"
          element={<LearningJourney />}
        />
        <Route path="assessments/manage" element={<Manage />} />
        <Route path="assessments/curriculam" element={<Curriculam />} />
        <Route path="assessments/assessreports" element={<AssessReports />} />

        <Route path="reports/excelreports" element={<ExcelReports />} />
        <Route path="reports/parentreports" element={<ParentReports />} />
        <Route path="reports/staffreports" element={<StaffReports />} />

        <Route path="forms/studentforms" element={<StudentForms />} />
        <Route path="forms/staffforms" element={<StaffForms />} />
        <Route path="forms/admissionprocess" element={<AdmissionProcess />} />
        <Route
          path="/forms/student-builder/:formId"
          element={<StudentFormBuilder />}
        />

        <Route path="forms/formbuilderpage" element={<FormBuilderPage />} />

        <Route path="calender/staffschedule" element={<StaffSchedule />} />
        <Route path="calender/studentschedule" element={<StudentSchedule />} />
        <Route path="calender/staffholidays" element={<StaffHolidays />} />
        <Route path="calender/birthdays" element={<Birthdays />} />
        <Route path="calender/schoolcalender" element={<SchoolCalendar />} />
      </Route>
      ;{/* 404 fallback */}
      <Route path="*" element={<div>404 Not Found</div>} />
    </Routes>
  );
}

export default AppRoutes;
